// @ts-check
// Sugestão automática de mapeamento coluna -> destino (doc 14, seção 9.3). No lugar do Fuse.js do Twenty, a
// semelhança é calculada sobre textos sem acento (Dice de bigramas e palavras contidas); cada destino recebe no
// máximo uma coluna, sempre a de maior semelhança.
import { headerSimilarity, normalizeForMatching } from './text-matching.js';

/** @typedef {import('./import-targets.js').ImportTarget} MatchTarget */

// abaixo disso a sugestão aparece só na lista do seletor, sem mapear sozinha
export const AUTO_MATCH_THRESHOLD = 0.78;
const MAXIMUM_SUGGESTIONS = 6;

/**
 * @param {string} header @param {MatchTarget} target
 */
export function scoreHeaderForTarget(header, target) {
  const normalized = normalizeForMatching(header);
  let best = 0;
  for (const alias of target.aliases) best = Math.max(best, headerSimilarity(normalized, alias));
  return best;
}

/**
 * @param {string[]} headers
 * @param {MatchTarget[]} targets
 * @returns {{ mapping: Array<string | null>, suggestions: string[][] }} mapping[índice da coluna] = chave do destino
 */
export function suggestColumnMapping(headers, targets) {
  /** @type {Array<{ columnIndex: number, targetKey: string, score: number }>} */
  const candidates = [];
  /** @type {string[][]} */
  const suggestions = headers.map(() => []);
  headers.forEach((header, columnIndex) => {
    const scored = targets
      .map((target) => ({ targetKey: target.key, score: scoreHeaderForTarget(header, target) }))
      .filter((item) => item.score > 0.3)
      .sort((left, right) => right.score - left.score);
    suggestions[columnIndex] = scored.slice(0, MAXIMUM_SUGGESTIONS).map((item) => item.targetKey);
    for (const item of scored) if (item.score >= AUTO_MATCH_THRESHOLD) candidates.push({ columnIndex, ...item });
  });
  candidates.sort((left, right) => right.score - left.score || left.columnIndex - right.columnIndex);
  /** @type {Array<string | null>} */
  const mapping = headers.map(() => null);
  const usedTargets = new Set();
  for (const candidate of candidates) {
    if (mapping[candidate.columnIndex] !== null || usedTargets.has(candidate.targetKey)) continue;
    mapping[candidate.columnIndex] = candidate.targetKey;
    usedTargets.add(candidate.targetKey);
  }
  return { mapping, suggestions };
}
